import {z} from 'zod';
import {zNumberToString} from '@brunata-angular/util';

export const fileAttachmentSchema = z.object({
    attachmentId: zNumberToString,
    attachmentSize: z.number(),
    attachmentUrl: z.string(),
    filename: z.string(),
    mimeType: z.string(),
    buildingNo: zNumberToString,
});

export type AttachmentFile = z.infer<typeof fileAttachmentSchema>;

export const fileAttachmentListSchema = z.array(fileAttachmentSchema);
